import { render, staticRenderFns } from "./VoucherPreview.vue?vue&type=template&id=6ef8ebe8&scoped=true&"
import script from "./VoucherPreview.vue?vue&type=script&lang=js&"
export * from "./VoucherPreview.vue?vue&type=script&lang=js&"
import style0 from "./VoucherPreview.vue?vue&type=style&index=0&id=6ef8ebe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8ebe8",
  null
  
)

export default component.exports